// extracted by mini-css-extract-plugin
export default {"block":"qe","info":"re","error":"se","noSpace":"te","optional":"ue"};